import { render, staticRenderFns } from "./HomeSteps.vue?vue&type=template&id=316b87f1"
import script from "./HomeSteps.vue?vue&type=script&lang=js"
export * from "./HomeSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports